import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import ChatMainView from '../component/ChatMainView'
import ChatParticipantsForm from '../../ChatParticipantsForm/container/ChatParticipantsForm'
import ChatMessagesList from '../../ChatMessagesList/container/ChatMessagesList'
import ChatMessageForm from '../../ChatMessageForm/container/ChatMessageForm'
import {
  sendMessage,
  createConversation,
  getConversation,
  markConversationAsRead,
} from '../../../../shared/websockets/chat/chat'
import { authorization } from '../../../../Module/Auth/Auth'
import { isAlreadyInConversationWithUser } from '../../../../shared/chat'
import { getParticipants, getProcessedMessages } from '../util'

const ChatMain = props => {
  const { websockets } = props
  const { messages, conversations, users, connected } = websockets

  const [participants, setParticipants] = useState([])
  const [formattedMessages, setFormattedMessages] = useState([])
  const [participantsType, setParticipantsType] = useState('')

  const {
    title,
    setTitle,
    activeConversationId,
    setActiveConversationId,
    isNewConversation,
    setIsNewConversation,
    setShouldShowArchivedConversations,
    isSpyChat,
  } = props

  useEffect(() => {
    if (!activeConversationId || !websockets.connected) {
      return setFormattedMessages([])
    }
    initialLoad()
  }, [activeConversationId])

  useEffect(() => {
    if (isNewConversation) {
      setFormattedMessages([])
    }
  }, [isNewConversation])

  /**
   *  Performs initial data load and marks conversation as read
   */
  const initialLoad = async () => {
    await markConversationAsRead({
      conversationId: activeConversationId,
      isEndUser: false,
    })
    await getConversation({ conversationId: activeConversationId })
    setIsNewConversation(false)
  }

  /**
   * Sends message to the conversation
   * @param {*} messageText
   */
  const onMessageSend = async ({ messagePayload }) => {
    if (isNewConversation && participants.length > 0) {
      const conversationId = await handleCreateConversation({
        participants,
        messagePayload,
      })
      setShouldShowArchivedConversations(false)
      setActiveConversationId(conversationId)
      setIsNewConversation(false)
      return setParticipants([])
    }
    sendMessage({ messagePayload, conversationId: activeConversationId })
  }

  const handleCreateConversation = async ({ participants, messagePayload }) => {
    const participantsIds = participants.map(({ id }) => id)

    const existingConversationId = isAlreadyInConversationWithUser({
      conversations: props.websockets.conversations,
      participantsIds,
      participantsType,
    })

    if (existingConversationId) {
      setTitle(conversations[existingConversationId].name)
      sendMessage({
        messagePayload,
        conversationId: existingConversationId,
      })
      return existingConversationId
    }

    const { id, name } = await createConversation({
      messagePayload,
      ack: 'CONV_CREATED',
      ...getParticipants(participants),
    })
    setTitle(name)
    setActiveConversationId(id)
    return id
  }
  useEffect(() => {
    if (!activeConversationId || !connected) return
    const currentConversation = conversations[activeConversationId]
    const { id: currentUserId } = authorization.getUser()

    if (
      formattedMessages.length !== currentConversation.orderedMessages.length
    ) {
      markConversationAsRead({
        conversationId: activeConversationId,
        isEndUser: false,
        dispatchPayload: {
          type: 'CHAT_CONVERSATION',
          id: activeConversationId,
          lastStaffReadTime: Date.now() + 200,
        },
      })
    }

    const updatedFormattedMessages = getProcessedMessages({
      currentConversation,
      messages,
      users,
      currentUserId,
    })

    setFormattedMessages(updatedFormattedMessages)
  }, [messages, users])

  return (
    <ChatMainView title={title}>
      {isNewConversation && (
        <ChatParticipantsForm
          participants={participants}
          setParticipants={setParticipants}
          setParticipantsType={setParticipantsType}
        />
      )}
      <ChatMessagesList
        messages={formattedMessages}
        conversation={conversations[activeConversationId]}
        isSpyChat={isSpyChat}
      />
      {((activeConversationId &&
        conversations[activeConversationId] &&
        !conversations[activeConversationId].archived) ||
        (isNewConversation && participants.length > 0)) && (
        <ChatMessageForm onMessageSend={onMessageSend} />
      )}
    </ChatMainView>
  )
}

ChatMain.propTypes = {
  activeConversationId: PropTypes.number,
  websockets: PropTypes.object,
}

const mapStateToProps = state => {
  return {
    websockets: state.websockets,
  }
}

export default connect(mapStateToProps)(ChatMain)



// WEBPACK FOOTER //
// ./src/Components/Chat/ChatMain/container/ChatMain.js